export const API_URL = import.meta.env.VITE_API_URL;
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL;
export const OPENWEATHER_KEY = import.meta.env.VITE_OPENWEATHER_KEY;
export const AZURA_LATITUDE = import.meta.env.VITE_AZURA_LATITUDE;
export const AZURA_LONGITUDE = import.meta.env.VITE_AZURA_LONGITUDE;
export const TOKEN_EXPIRATION_TIME = 'token_expiration_time';
